var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27724 2.92621L1.91548 12.2511C1.59621 12.8067 1.99736 13.5 2.63796 13.5H13.362C14.0021 13.5 14.4036 12.8065 14.0844 12.2511L8.72254 2.92597C8.72252 2.92595 8.72255 2.92599 8.72254 2.92597C8.4023 2.36929 7.59847 2.36894 7.27724 2.92621ZM6.41068 2.42714C7.11621 1.20207 8.88432 1.20156 9.58938 2.42739L14.9514 11.7528C15.6536 12.9747 14.7711 14.5 13.362 14.5H2.63796C1.22789 14.5 0.346367 12.9746 1.04844 11.7529L6.41068 2.42714ZM7.99996 5.50001C8.2761 5.50001 8.49996 5.72387 8.49996 6.00001V8.66668C8.49996 8.94282 8.2761 9.16668 7.99996 9.16668C7.72381 9.16668 7.49996 8.94282 7.49996 8.66668V6.00001C7.49996 5.72387 7.72381 5.50001 7.99996 5.50001Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34302 10.9627C8.54734 11.1484 8.56239 11.4647 8.37663 11.669L8.36997 11.6763C8.18421 11.8806 7.86798 11.8957 7.66366 11.7099C7.45933 11.5242 7.44428 11.208 7.63004 11.0036L7.63671 10.9963C7.82247 10.792 8.13869 10.7769 8.34302 10.9627Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.ea363ad7d5aedd709d71db4eebca7d49.svg";
export { ForwardRef as ReactComponent };